import { Node as ProseNode } from 'prosemirror-model'

/**
 * Checks if `maybeChild` is a descendant of `maybeParent` or if they are the same node
 * @param maybeParent the (potential) parent node
 * @param maybeChild the (potential) child node
 * @returns true if `maybeParent` contains `maybeChild` or if they are the same node
 */
export const isDescendantOrSame = (maybeParent: ProseNode, maybeChild: ProseNode) => {
  if (maybeParent === maybeChild) return true
  const childCount = maybeParent.childCount
  if (childCount === 0) return false
  for (let i = 0; i < childCount; i++) {
    const child = maybeParent.child(i)
    if (isDescendantOrSame(child, maybeChild)) return true
  }
}
